export default () => {
    return(
    <>
        <h1>DASHBOARD</h1>
    </>
    
    
    ); 
}